import { ChevronLeft } from '@bnnvara/icons/src/components/UserInterfaceIcons/ChevronLeft';
import React from 'react';
import * as S from './styled';

export const HeroPrevArrow = (
  <S.SlideArrow
    role="button"
    aria-label="Ga naar het vorige item"
    title="Ga naar het vorige item"
  >
    <ChevronLeft />
  </S.SlideArrow>
);
